<!--3d等弹层-->
<template>
  <section>
    <!--3d展厅-->
    <div
      id="vr-layer-iframe-3d"
      class="dlrLayer-iframe"
      v-show="threeDimensionHall.show"
      :style="threeDimensionHall.style"
    >
      <iframe
        ref="vr-layer-iframe-3d"
        v-if="threeDimensionHall.show"
        :src="url"
        frameborder="0"
        scrolling="no"
        :width="fullFrame.width"
        :height="fullFrame.height"
        border="0"
        allowtransparency="true"
        @load="threeDimensionHallLoad"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { URLService } from '../../services/url.service';
import config from '../../config';
export default {
  computed: {
    ...mapGetters({
      'threeDimensionHall': 'frame/threeDimensionHall',
      'fullFrame': 'frame/fullFrame',
      'sceneList': 'scene/sceneList',
      baseInfo: 'baseInfo',
      hasVideo: 'hasVideo'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    },
    fdRight () {
      const fdRight = this.baseInfo.fdRight;
      if (fdRight.hasRights && fdRight.hasPublish && fdRight.sceneId) {
        return true;
      }
      return false;
    },
  },
  data () {
    return {
      url: 'about:blank'
    };
  },
  created () {
    this.url = this.bulidHallUrl();
  },
  mounted () {
    const self = this;

    const handler = function (event) {
      if (event.target.tagName === 'input') {
        var hallFrame = self.$refs['vr-layer-iframe-3d'];
        if (hallFrame) {
          hallFrame.contentWindow.postMessage('inputblur', '*');
        }
      }
    };
    document.addEventListener('focusout', handler);
  },
  methods: {
    bulidHallUrl () {
      const dealerId = this.dealerId;
      const urlSerivce = new URLService(config.hall3dUrl);
      const queryParams = this.$queryParams;
      let showVrBtn = 0;
      if (this.sceneList.length > 0 || this.fdRight) {
        showVrBtn = 1;
      }
      urlSerivce.queryParams
        .append('dealerid', dealerId)
        .append('hasvideo', this.hasVideo ? 1 : 0)
        .append('busi', 'vr')
        .append('cityId', this.baseInfo.cityId)
        .append('showVrBtn', showVrBtn)
        .append('pvareaid', 2594195)
        .append('from', queryParams.from)
        .append('t', new Date().getTime());
      const url = urlSerivce.build();
      return url;
    },
    threeDimensionHallLoad () {
      const self = this;
      var hallFrame = self.$refs['vr-layer-iframe-3d'];


      if (self.sceneList.length === 0 && !self.fdRight) {
        hallFrame.contentWindow.postMessage({
          action: 'hidevrbtn',
          param: {
            hidden: true
          }
        }, '*');
      }

      hallFrame.contentWindow.postMessage({
        param: {
          cityId: self.baseInfo.cityId
        }
      }, '*');
    }
  }
};
</script>
<style lang="scss">
.dlrLayer-iframe {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
}
.loadding-xx {
  width: ptrd(66px);
  height: ptrd(66px);
  position: absolute;
  top: ptrd(30px);
  right: ptrd(30px);
  z-index: 120;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAADCElEQVRoQ92aP8hOURjAf7coA4kMIl8hiwxIESXDFwMGg8nEgEUZbVaDwWD4GJhMBoPPQAYpMgiDLEIRGURiUNSr5+uc27nXPe895znneHvvu73v+/z7nT/P85xzb8VAPlVGjpXAJmAGWA3I92XAEmAR8Af4BfwAvgKfgffAa/M9KZRUkKXAdmAzsAFYrojmO/AWeAU8A34qbKAFWQHsAbYC6zSOPTofgBfAI+BbjF0NyD5gF7A+xlGk7DvgCfAgVC8GZC2wH9hh1nyoD62c7KmnwD3gY5+RUBBZQgKxsc9ggf/fGBhZct5PCMhu4IDJRAXiDDIpGe4u8Ngn3QciEAeBVUHuygp9Ae74YMaByHI6MuGZaA+NzMwtk9ka//lAZGMfm9Ce6JtX2TM32gnAB3LcpNg+o5P6X1Lzddd5F4jUiaP/KcVqB0JS8023zrRBpGKfCil2o9HopERRVdVVbTRdehF2pWhesR1AG+QQcDgkMOswJ4zC5m1gfiEGJ2hpAM/G9E4Kx94xUtqS3uySNJouyF6TqUImpJZRBtDwkWhDMthDF+Q0sC2KwginBJKia9w/B+YsiByCzinPEwv2NAFpdDoGWs4zFyzITuCEZjZcnZjAYmQD4rpmQaRuzAYo9IqEBBgi0+uoKXDfgpwBtkQqqzJQAQiJ46UFOQ+syQXi2zOFIMTdJwty0dx45GRpJADXcO5uQG5mLMhlYHFWio7UnLMLaMX624LMtap8NiZ3ORUEGRWdkTaEHZ0CS6uekex7pGtjF9zs9R7JmrXGBVwIps5a2epISKAhMpGbtK4jWSp7TIAxsgFQdWVP7rU0gWl0PFB1r5XU/aYElKJroBrdr/ymOo9kCER1BHBmpnEekd+jT4g5IGxACbb+OSFGndkTHKu6Zo9S55ldZKNvUXJXaTtAgXY7b1EEJPheKyAllhYZe68lzgdx02hHcRB3vwIzmNt4gRnE8xG7xAbxxMqFmfpniBZmEE91LcwgnrO7xW3q33xwYQbxLooLNPVvB3X1URN9X+svS0M3LroPCNAAAAAASUVORK5CYII=)
    no-repeat center center;
  background-size: 100%;
}
</style>
